import {
    GlazePlugin,
    InputPlugin,
    LinesPlugin,
    minimalLight,
    OrbitPlugin,
    PartPlugin,
    type Plugin,
    RenderPlugin,
    run,
    SearPlugin,
    SlabPlugin,
    TransformsPlugin,
} from "@dylanebert/shallot";

// Shared boot for the harmony demos, mirroring the shallot visualization showcase: the kitchen render
// stack + lines + orbit. The camera, lights, and content live in each demo's `.scene` — a lone
// `<a camera sear orbit transform>` auto-binds to the page's <canvas> and orbits the origin, so the
// single-view case needs no code. Each demo passes the extra plugin(s) its scene references. Pitch is
// clamped and zoom disabled per camera in the scene (min-pitch / max-pitch / zoom-speed); yaw is free.
// HMR disposes the State. The iframe is sized by a fixed aspect-ratio in the post (.demo-frame), so no
// height messaging is needed.
export async function start(plugins: Plugin[], scene: string) {
    const { dispose } = await run({
        defaults: false,
        scene,
        loading: minimalLight(),
        plugins: [
            SlabPlugin,
            TransformsPlugin,
            InputPlugin,
            OrbitPlugin,
            RenderPlugin,
            PartPlugin,
            SearPlugin,
            GlazePlugin,
            LinesPlugin,
            ...plugins,
        ],
    });

    if (import.meta.hot) {
        import.meta.hot.dispose(() => dispose());
    }
}
